<ada-spinner *ngIf="(errorMessage | async) === ''" />
<ada-alert
	*ngIf="errorMessage | async"
	type="error"
	style="max-width: 24rem"
	[isClosable]="false"
	[title]="errorMessage | async"
/>
